import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

/**
 * Toast estándar del ERP: encabezado "Mensaje del sistema" y cuerpo centrado.
 */
export default function SistemaToast({
  show = false,
  message = '',
  onClose,
  delay = 3000,
  zIndex = 10060,
  position = 'top-center',
  width = 'min(35vw, 420px)',
}) {
  return (
    <ToastContainer
      className="p-3"
      position={position}
      style={{ zIndex, maxWidth: 'unset' }}
    >
      <Toast
        style={{ width }}
        onClose={onClose}
        show={show}
        delay={delay}
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">Mensaje del sistema</strong>
        </Toast.Header>
        <Toast.Body className="text-center">{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}
